import { styled } from 'styled-components'
import {
  responsiveMaxWidth,
  responsivePadding,
} from 'common-ui-components/src/vtj/theme/helpers'
import variables from 'common-ui-components/src/vtj/theme/variables'
import colors from 'common-ui-components/src/vtj/theme/colors'
import media from 'common-ui-components/src/vtj/theme/media'
import fonts from 'common-ui-components/src/vtj/theme/fonts'

const { fontSize, textLineHeight, smallFontSize, desktopPadding } = variables
const { mobileAndTablet, mobile } = media
const { visitedLinkColor, infoBackgroundColor, textLightColor, textColor } =
  colors

export const UnsupportedBrowserBannerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-top: 12px;
  padding-bottom: 12px;
  background-color: ${infoBackgroundColor};
`

export const UnsupportedBrowserBannerContent = styled.div`
  ${responsivePadding()};
  ${responsiveMaxWidth()};
  display: flex;
  margin: 0 auto;
`

export const MessageContent = styled.div`
  display: flex;
  flex-direction: column;
`

export const DescriptionWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const DescriptionText = styled.p`
  padding-left: ${desktopPadding}px;
  margin: 0;
  font-family: ${fonts.semiBoldFont};
  font-size: ${fontSize}px;
`

export const BrowserLinks = styled.div`
  padding-left: ${desktopPadding + 24}px;
  display: flex;
  align-content: flex-start;
`

export const BrowserLinkItem = styled.div`
  padding-top: 10px;
  margin-right: 30px;
  > a {
    color: ${textColor};
    text-decoration: underline;
  }
  > a:visited {
    color: ${visitedLinkColor};
  }
  ${mobile} {
    font-size: ${smallFontSize}px;
    margin: auto;
  }
`

export const CloseButton = styled.button`
  display: flex;
  ${mobileAndTablet} {
    align-self: flex-start;
    align-items: flex-start;
    padding-right: 0;
    height: ${smallFontSize * textLineHeight}px;
  }
  height: initial;
  align-items: center;
  margin-left: auto;
  padding-left: 18px;
  cursor: pointer;
  border: none;
  background: none;
`

export const CloseText = styled.span`
  color: ${textLightColor};
  text-transform: uppercase;
  font-size: ${fontSize}px;
  margin-right: 10px;
  ${mobileAndTablet} {
    display: none;
  }
`
